import type { Table } from "@tanstack/react-table";
import type { ITarea } from "../../../modelos/Tarea/entidades/ITarea";
import type { IProyecto } from "../../../modelos/Proyectos/entidades/IProyecto";
import type { IEquipo } from "../../../modelos/Equipo/entidades/IEquipo";
import type { ICatalogo } from "../../../globales/interfaces";
import type { IUsuario } from "../../../modelos/Usuario/entidades/IUsuario";
import type { ICliente } from "../../../modelos/Clientes/entidades/ICliente";
import type { IFiltroTarea } from "../../../modelos/Tarea/entidades/IFiltroTarea";
import type { ITareaFormulario } from "./ITareaFormulario";
import dayjs from "dayjs";
import { EnumEstadoTarea } from "../enums/enumEstadoTarea";
import type { IModulo } from "../../../modelos/ModulosCheckList/entidades/IModulo";
import type { ITareaCancelar } from "../../../modelos/Tarea/entidades/ITareaCancelar";
import type { ICausalCancelacion } from "../../../modelos/CausalCancelacion/entidades/ICausalCancelacion";
import type { IPais } from "../../../modelos/Ubicacion/entidades/IPais";
import type { ITareaRechazada } from "../../../modelos/Tarea/entidades/ITareaRechazada";
import type { IHabilitacionVisitaInstalacion } from "../../../modelos/Tareas/entidades/IHabilitacionVisitaInstalacion";


export interface ITablaTareasVistaProps extends IFiltroTareasVistaProps {
    tabla: Table<ITarea>;
    abrirModalTarea: (estadoModal: boolean, tarea: ITarea) => void;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    limpiarFiltros: () => void;
    descargarPlantilla: () => Promise<void>;
    cargaMasivaTareas: () => void;
    abrirModalExportacionExcel: (estadoModal: boolean) => void;
    estadoModalExportacionExcel: boolean;
}

export interface IModalTareaCVProps {
    consultarTareas: () => void;
    abrirModalTarea: (estadoModal: boolean, tarea: ITareaFormulario | null, visualizacion?: boolean) => void;
    estadoModal: boolean;
    entidadTarea: ITareaFormulario;
    setEntidadTarea: React.Dispatch<React.SetStateAction<ITareaFormulario>>;
    esEmergencia: boolean;
    visualizacion: boolean;
    entidadesRegistro?: IEntidadesRegistroTarea;
}

export interface IModalTareaVistaProps {
    abrir: boolean;
    abrirModalTarea: (estadoModal: boolean, tarea: ITareaFormulario) => void;
    tareaSeleccionado: ITareaFormulario;
    guardarEditarTarea: () => void;
    manejarCambioValorTarea: (campo: keyof ITareaFormulario, valor: ITareaFormulario[keyof ITareaFormulario]) => void;
    entidadesRegistro: IEntidadesRegistroTarea;
    agregarError: (campo: keyof ITareaFormulario, error: string) => Promise<void>,
    errores: Partial<Record<keyof ITareaFormulario, string | null>>;
    consultarPorNumeroContrato: (numero: string) => void;
    consultarPorCodigoEquipo: (codigo: string) => void;
    visualizacion: boolean;
    tienePermisoNBS: boolean;
}

export const crearEstadoInicialTarea = (): ITareaFormulario => ({
    Id: undefined,
    ProyectoId: 0,
    EquipoId: 0,
    TipoServicioId: 0,
    EstadoId: EnumEstadoTarea.Creada,
    FechaInicio: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    FechaFin: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    EsEmergencia: false,
    CreadaUtc: '',
    CreadaPor: 0,
    AsignadaA: 0,
    CausalEmergenciaId: null,
    ModulosChecklist: [],
    FinalizacionPunto: '',
    LLegadaPunto: '',
    ClienteId: 0,
    NumeroContrato: '',
    CodigoEquipo: '',
    Duracion: 0,
    TipoVisitaInstalacionId: null,
    SeccionesChecklist: null
});

export const estadoInicialTarea: ITareaFormulario = crearEstadoInicialTarea();

export interface IEntidadesRegistroTarea {
    Proyectos: IProyecto[];
    ProyectosTodos: IProyecto[];
    Clientes: ICliente[];
    ClientesTodos: ICliente[];
    Tecnicos: IUsuario[];
    TecnicosTodos: IUsuario[];
    Equipos: IEquipo[];
    EquiposTodos: IEquipo[];
    TiposTarea: ICatalogo[];
    EstadosTarea: ICatalogo[];
    ModulosCheckList: IModulo[];
    ModulosCheckListTodos: IModulo[];
    CausalesEmergencia: ICatalogo[];
    Paises: IPais[];
    HabilitacionesNBS: IHabilitacionVisitaInstalacion[];
}

export interface IFormularioInformacionTareaVistaProps {
    guardarEditarTarea: () => void;
    manejarCambioValorTarea: (campo: keyof ITarea, valor: ITarea[keyof ITarea]) => void;
    entidadesRegistro: IEntidadesRegistroTarea;
    abrirModalTarea: (estadoModal: boolean, tarea: ITarea) => void;
    agregarError: (campo: keyof ITarea, error: string) => Promise<void>;
    errores: Partial<Record<keyof ITarea, string | null>>;
    regexLat: RegExp;
    regexLng: RegExp;
    pantallaCompleta: boolean;
}


export interface IFiltroTareasVistaProps {
    filtro: IFiltroTarea;
    consultarTareas: () => void;
    manejarCambioFiltroTarea: (campo: keyof IFiltroTarea, valor: IFiltroTarea[keyof IFiltroTarea]) => void;
    entidadesRegistro: IEntidadesRegistroTarea;
    limpiarFiltros: () => void;
    estadoModalExportacionExcel: boolean;
}

export interface IModalCancelarTareaCVProps {
    abrirModalCancelarTarea: (estadoModal: boolean, tarea: ITarea | null) => void;
    estadoModal: boolean;
    tareaSeleccionado: ITarea;
}

export const estadoInicialFiltroTarea: IFiltroTarea = {
    ClienteId: null,
    EstadoId: null,
    ProyectoId: null,
    TecnicoId: null,
    TipoServicioId: null,
    TareaId: null,
    FechaInicio: null,
    FechaFin: null,
    CodigoEquipo: null,
    PaisId: null
}

export interface IModalExportacionExcelTareasCVProps {
    abrirModalExportacionExcel: (estadoModal: boolean) => void;
    estadoModal: boolean;
    filtro: IFiltroTarea;
    consultarTareas: () => void;
    manejarCambioFiltroTarea: (campo: keyof IFiltroTarea, valor: IFiltroTarea[keyof IFiltroTarea]) => void;
    entidadesRegistro: IEntidadesRegistroTarea;
    limpiarFiltros: () => void;
    tabla: Table<ITarea>;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    habilitarFiltros: boolean;
    hayRegistros: boolean;
    exportarTareasExcel: () => void;
}

export interface IModalCancelarTareaVistaProps {
  abrir: boolean;
  abrirModal: (estadoModal: boolean, tarea: ITarea | null) => void
  tareaSeleccionado: ITarea;
  datosCancelacion: ITareaCancelar;
  alCambiarValor: (campo: keyof ITareaCancelar, valor: ITareaCancelar[keyof ITareaCancelar]) => Promise<void>;
  guardarCancelacion: () => void;
  errores: {
    causalCierre?: string;
    observacion?: string;
  };
  causalesCancelacion: ICausalCancelacion[];
}

export interface IModalErroresCargaMasivaProps {
  abrir: boolean;
  onClose: () => void;
  rechazadas: ITareaRechazada[];
  totales: {
    guardadas: number;
    rechazadas: number;
  };
}
